<style lang="scss">
@import "../styles/error404.scss";
@import "@/styles/color";
@import "@/styles/typography";
</style>

<template>
  <v-app>
    <v-container>
      <v-layout justify-center align-center fill-height>
        <v-flex xs12 sm8 lg6 style="text-align: center">
          <p class="sleek-title-4">Oops! Page not found.</p>
          <img src="/imgs/error404.svg" class="error404-img" />
          <p class="sleek-body-6 error404-subtitle">Sorry, we couldn't find the page you are looking for.</p>
          <v-btn color="primary" @click="handleBackClick">Back to Main Page</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
// Maps
import { applySiteSettings } from "@/utilities/partner-util";

import { Constants } from "customer-sdk/constants";

const PAGE_URLS = Constants.PAGE_URLS;
export default {
  name: "Error404Page",
  beforeCreate() {
    applySiteSettings();
    console.log("this pageURLS:: ", PAGE_URLS);
  },
  methods: {
    handleBackClick: function () {
      this.$router.push(PAGE_URLS.HOME);
    },
  },
};
</script>
